<script lang="ts">
  import { cyan } from 'design/src/tokens/colors';
  import { difference } from 'shared/src/utils/difference';
  import type { NoteName } from 'shared/definitions/musicTheory/notesAndAccidentals';
  import { uniqueFilter } from 'shared/src/utils/uniqueFilter';
  import { onMount, createEventDispatcher } from 'svelte';
  import type Note from '../../uTheory.Notation/note';
  import PianoSVG from './pianosvg';

  export let isInteractive: boolean = false;
  export let isMidiInteractive: boolean = false;
  export let lowestNote: Note | NoteName = 'C3';
  export let highestNote: Note | NoteName = 'C5';
  export let height = 200;
  export let highlightColor = cyan[500];
  /**
   * Keys pressed via the GUI interface
   */
  export let pressedMidis: number[] = [];
  /**
   * Other notes that should be highlighted, even if not pressed via the GUI interface
   */
  export let otherHighlightedMidis: number[] = [];
  export let sticky = false;

  let clazz = '';
  export { clazz as class };

  let pianoSVG: PianoSVG | undefined;
  let pianoDiv: HTMLDivElement;

  export function clear() {
    pressedMidis = [];
    pianoSVG?.clearColors();
  }

  const dispatch = createEventDispatcher<{
    noteOn: { midiNumber: number };
    noteOff: { midiNumber: number };
  }>();

  onMount(() => {
    pianoSVG = new PianoSVG(pianoDiv, {
      lowestNote,
      highestNote,
      listeners: isInteractive,
      midiListeners: isMidiInteractive,
      pressedColor: highlightColor,
    });

    pianoSVG.resize(height);

    pianoSVG.addNoteOnListener((midi) => {
      if (sticky) {
        console.log('sticky');
        if (pressedMidis.find((m) => midi === m)) {
          console.log('found');
          removeNote(midi);
        } else {
          addNote(midi);
        }
      } else {
        addNote(midi);
      }
    });
    pianoSVG.addNoteOffListener((midi) => {
      if (sticky) return;
      removeNote(midi);
    });
  });

  export function addNote(midiNumber: number) {
    if (pressedMidis.find((m) => m === midiNumber)) return;
    pressedMidis = [...pressedMidis, midiNumber].filter(uniqueFilter);
    dispatch('noteOn', { midiNumber });
  }

  export function removeNote(midiNumber: number) {
    if (!pressedMidis.find((m) => m === midiNumber)) return;
    pressedMidis = pressedMidis.filter((m) => m !== midiNumber);
    dispatch('noteOff', { midiNumber });
  }

  function resize(h: number) {
    if (pianoDiv) pianoDiv.style.height = `${h}px`;
    pianoSVG?.resize(h);
  }

  $: {
    pianoSVG?.setBoundaries(lowestNote, highestNote);
    console.log(`Resize: ${height}`);
    if (pianoDiv) pianoDiv.style.height = `${height}px`;
    resize(height);
  }

  // Notes that should be colored:
  $: coloredNotes = [...pressedMidis, ...otherHighlightedMidis].filter(uniqueFilter);

  $: {
    // Notes to uncolor:
    difference(pianoSVG?.getHighlightedNotes() || [], coloredNotes).forEach((midi) =>
      pianoSVG?.clearNoteColoring(midi),
    );
    // Notes to color:
    difference(coloredNotes, pianoSVG?.getHighlightedNotes() || []).forEach((midi) => {
      pianoSVG?.colorNote(midi);
    });
  }

  $: pianoSVG?.setPressedColor(highlightColor);
  $: pianoSVG?.setInteraction(isInteractive, isMidiInteractive);
</script>

<svelte:window
  on:resize={() => {
    resize(height);
  }}
/>

<!-- <p>Colored Midis: {coloredNotes}</p>
<p>Pressed Midis: {pressedMidis}</p>
<p>Other highlighted midis: {otherHighlightedMidis}</p> -->
<div bind:this={pianoDiv} class="{clazz} mx-auto" style="height: {height}px" />
